import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=02b6e1e8&"
import script from "./ExpansionPanel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExpansionPanel.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports